var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-id-presenter"},[_vm._v(" "+_vm._s(_vm.video.publish_date ? _vm.simpleDate : 'N/A')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }